<template>
  <inventoryProductsList/>
</template>
<script>
import inventoryProductsList from '@/components/modules/papeleria/products/list'
export default {
  name: 'inventoryProducts',
  components: {
    inventoryProductsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/papeleria/products/list.vue